import { useEffect, useState } from "react";
import { fetchWindowsRelease, hasApprovedWindowsRelease, windowsSaleOpen } from "@/lib/windowsReleases";
import { fetchConsumerCatalog } from "@/lib/consumerCommerce";

export function useWindowsRelease(product, owned = true) {
  const [state, setState] = useState({ loading: true, release: null, available: false });
  useEffect(() => {
    let active = true;
    setState({ loading: true, release: null, available: false });
    if (!owned && !hasApprovedWindowsRelease(product)) {
      setState({ loading: false, release: null, available: false });
      return () => { active = false; };
    }
    // Latest is an authenticated, paid download API. Before purchase, use only
    // the reviewed launch input and the existing public price catalog.
    const request = owned ? fetchWindowsRelease(product) : fetchConsumerCatalog();
    request.then((data) => {
      if (active) setState({ loading: false, release: owned ? data : null,
        available: owned ? true : windowsSaleOpen(product, data) });
    }).catch(() => { if (active) setState({ loading: false, release: null, available: false }); });
    return () => { active = false; };
  }, [product, owned]);
  return state;
}
